import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { QueueService } from 'src/app/moov-common/services/utils/queue.service';
import { SelectableResponseStateEnum } from '../discovery-process.enum';
import { DiscoveryWizardBaseCurrentQuestionComponent } from '../discovery-wizard-base-current-question/discovery-wizard-base-current-question.component';
import { ResponseGapState } from '../discovery-wizard-current-question-gap/discovery-wizard-current-question-gap.component';
import { DiscoveryResponse } from '../model/discovery-chat.interface';

@Component({
  selector: 'app-discovery-wizard-current-question-tail',
  templateUrl: './discovery-wizard-current-question-tail.component.html',
  styleUrls: ['./discovery-wizard-current-question-tail.component.scss'],
  animations: [
      trigger('slideInOut', [
        state('in', style({
            'opacity': '0.5', 'background-color': '#FA982B'
        })),
        state('out', style({
            'opacity': '1', 'background-color': '#FFFFFF'
        })),
        transition('in => out', [group([
            animate('50ms ease-in-out', style({
              'background-color': '#FFFFFF'
            })),
            animate('50ms ease-in-out', style({
                'opacity': '1'
            }))
        ]
        )]),
        transition('out => in', [group([
            animate('50ms ease-in-out', style({
              'background-color': '#FA982B'
            })),
            animate('50ms ease-in-out', style({
                'opacity': '0.5'
            }))
        ]
        )])
    ]),
  ]
})

export class DiscoveryWizardCurrentQuestionTailComponent extends DiscoveryWizardBaseCurrentQuestionComponent implements OnInit {

  possibleResponses: ResponseGapState[] = [];
  reponsesStateMap: Map<string, SelectableResponseStateEnum>; 
  selectedReponsesQueue: QueueService<string> = new QueueService<string> ();
  state = 'out';
  questionsVideoFolder = 'assets/media/questions/';
  currentQuestionVideoAssetName : string = "";
  isVideoMuted : boolean = false;
  @ViewChild('currentQuestionVideo') questionVideo: ElementRef;
  @Input() presentConsultantVideo: boolean = false;

  constructor() { 
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.selectedReponsesQueue.clear();
    this.buildResponsesStateArray();
    this.evaluateNextQuestionButton();
    this.evaluatePlayVideo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.currentQuestion){
      return;
    }

    if (changes.currentQuestion.currentValue != changes.currentQuestion.previousValue && !changes.currentQuestion.firstChange){
      if (this.currentQuestion !== undefined) {
        // this.focusOnElementOnChat(this.topChat);
        this.selectedReponsesQueue.clear();
        this.buildResponsesStateArray();
        this.evaluateNextQuestionButton();
        this.evaluatePlayVideo();
          }
      }
    }

    ngAfterViewInit(): void{
    
      this.playVideo();
    }

    evaluatePlayVideo() : void{
      console.log (`dwcqt evaluatePlayVideo curr question is ${JSON.stringify(this.currentQuestion)}`);
      if (!this.presentConsultantVideo){
        // no video is required to be played
        return;
      }

      if (this.currentQuestion?.batchId != tailQuestionBatchId){
        // even though we were require to present video - there is no video to present
        this.presentConsultantVideo = false;
      }
    }

    buildResponsesStateArray(): void{
      if (!this.currentQuestion){
        return;
      }
      
      //DBG
      console.log (`DBG DWCQG buildResponsesStateArray q size is ${this.selectedReponsesQueue.size()} userResponseNo is ${this.currentQuestion.userResponsesNo}`);

      this.possibleResponses = [];
  
      for (let currPossibleResponse of this.currentQuestion.possibleResponses){
          let responseState = new ResponseGapState();
          responseState.responseData = currPossibleResponse;
  
          if (this.selectedReponsesQueue.exists(responseState.responseData.id))
          {
            responseState.state = SelectableResponseStateEnum.Selected;
          }
          else if (this.selectedReponsesQueue.size() < this.currentQuestion.userResponsesNo){
            // No selected response - all responses are enabled
            responseState.state = SelectableResponseStateEnum.Enabled;
          }
          else if (this.selectedReponsesQueue.size() == this.currentQuestion.userResponsesNo && !this.selectedReponsesQueue.exists(responseState.responseData.id)){
            responseState.state = SelectableResponseStateEnum.Disabled;
          }
          else{
            responseState.state = SelectableResponseStateEnum.Enabled;
          }
  
          this.possibleResponses = this.possibleResponses.concat(responseState);
      }
    }

    reponseClicked(resId: string): void{
       if (!this.selectedReponsesQueue.exists(resId)){
        this.selectedReponsesQueue.enqueue(resId);
       }

       if (this.selectedReponsesQueue.size() > this.currentQuestion!.userResponsesNo){
        // remove first response in queue
        this.selectedReponsesQueue.dequeue();
       }
 
      this.buildResponsesStateArray();
      this.evaluateNextQuestionButton();
    }

    evaluateNextQuestionButton(): void{
      if (!this.currentQuestion){
        this.isAllResponsesAnswered = false;
        return;
      }

      this.isAllResponsesAnswered = false;
    
      if (this.selectedReponsesQueue.size() == this.currentQuestion.userResponsesNo){
        this.isAllResponsesAnswered = true;
      }
    }

    async nextQuestionAnimation() {
      this.state = 'in';
      await this.utilsService.delay(0.2);  
      this.state = 'out';
    }

    submitResponse(): void{
        if (!this.currentQuestion){
          this.sendQuestionResponseEvent.emit([]);
          return;
        }
    
        let responses : DiscoveryResponse[] = [];
        
        let currResponse = this.selectedReponsesQueue.dequeue();

        while (currResponse){
          let userResponse = {questionId:this.currentQuestion.id, responseId:currResponse};

          responses = responses.concat(userResponse);

          currResponse = this.selectedReponsesQueue.dequeue();
        }
      
        this.sendQuestionResponseEvent.emit(responses);
     }

     playVideo(): void{
      if (!this.presentConsultantVideo || this.currentQuestion == undefined || this.questionVideo == undefined){
        return
      }

      this.currentQuestionVideoAssetName = this.utilsService.buildVideoNameByGenderAndLocale(this.questionsVideoFolder + tailQuestionVideoId, '.mp4', this.user!);
      console.log(`dwcqt playVideo ${this.currentQuestionVideoAssetName}`);
      const media = this.questionVideo.nativeElement;
      if (this.isVideoMuted){
        media.muted = true;
      }
      else{
        media.muted = false;
      }

      media.play();
    }
    
    muteConsultantVideo() : void{
      this.isVideoMuted = !this.isVideoMuted;
    
      const media = this.questionVideo.nativeElement;
      if (this.isVideoMuted){
        media.muted = true;
        this.analytics.UserMutedQuestionVideo();
      }
      else{
        media.muted = false;
        this.analytics.UserUnMutedQuestionVideo();
      }
    }
}

export const tailQuestionBatchId : string = 'B99';
export const tailQuestionVideoId : string = 'Q099';

